var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcAddSurvey = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M7.75 1.41a6.34 6.34 0 1 0 0 12.68 6.34 6.34 0 0 0 0-12.68M0 7.75a7.75 7.75 0 1 1 15.5 0 7.75 7.75 0 0 1-15.5 0",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M7.75 4.227c.39 0 .705.315.705.705v5.636a.705.705 0 0 1-1.41 0V4.932c0-.39.316-.705.705-.705",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M4.227 7.75c0-.389.315-.704.705-.704h5.636a.705.705 0 0 1 0 1.409H4.932a.705.705 0 0 1-.705-.705",
  clipRule: "evenodd"
})));
export default SvgIcAddSurvey;